import { Dropdown, Icon } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import CashflowAreaDropdown from "../../cashflowAreaDropdown";
import { PaymentDaysDropdown } from "../../paymentDaysDropdown/paymentDaysDropdown";
import SelectorEERR from "../../selectorEERR";
import { FULL_ACCESS_PLANS, Plans } from "src/utils/plans";
import { FlowLVL } from "src/utils/flujoCaja";
import FeatherIcon from "feather-icons-react";
import "./ContactParametrization.scss";

export const ContactParametrization = ({
  variables,
  companyPlans,
  companyId,
  loading,
  labelIcon,
  companyLabels,
  onChange,
  onSubmit,
}) => {
  const { t } = useTranslation("agenda");
  const showEERRClient =
    !companyPlans.includes(Plans.estado_de_resultados) &&
    FULL_ACCESS_PLANS.some((p) => companyPlans.includes(p));
  const showEERRProvider =
    companyPlans.includes(Plans.estado_de_resultados) ||
    FULL_ACCESS_PLANS.some((p) => companyPlans.includes(p));

  return (
    <div className="contact-parametrization parametrizacion-tab-content">
      {variables?.isClient && (
        <>
          <div className="parametrizacion-section">
            <span className="parametrizacion-section-title">{t("parametrization.client")}</span>
            <div className="field-row">
              <div className="field field--wide">
                <label className="label">
                  {t("parametrization.cashflowArea")} <span style={{ color: "#dc2626" }}>*</span>
                </label>
                <CashflowAreaDropdown
                  editData={{
                    cashflowAreaId: variables.defaultCashflowAreaClient,
                  }}
                  onChange={(v) => onChange("defaultCashflowAreaClient", v)}
                  limit={[FlowLVL.INCOME]}
                />
              </div>
              <div className="field field--narrow">
                <label className="label">
                  {t("parametrization.paymentDays")} <span style={{ color: "#dc2626" }}>*</span>
                </label>
                <PaymentDaysDropdown
                  editData={variables.paymentDaysClient}
                  onChange={(v) => onChange("paymentDaysClient", parseFloat(v))}
                />
              </div>
            </div>
            {showEERRClient && (
              <div className="field">
                <label className="label">
                  {t("parametrization.eerrArea")}{" "}
                  <span style={{ color: "#dc2626" }}>*</span>
                </label>
                <SelectorEERR
                  value={variables.defaultEERRAreaClient}
                  onChange={(_, v) =>
                    onChange("defaultEERRAreaClient", v?.value)
                  }
                  placeholder={t("parametrization.clientAreaPlaceholder")}
                  companyId={companyId}
                />
              </div>
            )}
          </div>
        <div className="parametrization-divider" />
        </>
      )}

      {variables?.isProvider && (
        <div className="parametrizacion-section">
          <span className="parametrizacion-section-title">{t("parametrization.provider")}</span>
          <div className="field-row">
            <div className="field field--wide">
              <label className="label">
                {t("parametrization.cashflowArea")} <span style={{ color: "#dc2626" }}>*</span>
              </label>
              <CashflowAreaDropdown
                editData={{
                  cashflowAreaId: variables.defaultCashflowAreaProvider,
                }}
                onChange={(v) => onChange("defaultCashflowAreaProvider", v)}
                limit={[FlowLVL.EXPENSE]}
              />
            </div>
            <div className="field field--narrow">
              <label className="label">
                {t("parametrization.paymentDays")} <span style={{ color: "#dc2626" }}>*</span>
              </label>
              <PaymentDaysDropdown
                editData={variables.paymentDaysProvider}
                onChange={(v) =>
                  onChange("paymentDaysProvider", parseFloat(v))
                }
              />
            </div>
          </div>
          {showEERRProvider && (
            <div className="field">
              <label className="label">
                {t("parametrization.eerrArea")}{" "}
                <span style={{ color: "#dc2626" }}>*</span>
              </label>
              <SelectorEERR
                value={variables.defaultEERRAreaProvider}
                onChange={(_, v) =>
                  onChange("defaultEERRAreaProvider", v?.value)
                }
                placeholder={t("parametrization.providerAreaPlaceholder")}
                companyId={companyId}
              />
            </div>
          )}
          <div className="field">
            <label className="label">{t("parametrization.providerClassification")}</label>
            <div className="dropdown-wrapper">
              <Dropdown
                selectOnBlur={false}
                icon={false}
                fluid
                button
                basic
                text={
                  labelIcon?.key === "sinetiqueta" || !labelIcon ? (
                    <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <Icon name="add" />
                      <span className="custom-provider-type-color">
                        {t("parametrization.addLabel")}
                      </span>
                    </span>
                  ) : (
                    <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <FeatherIcon
                        icon={labelIcon?.icon}
                        color={labelIcon?.color}
                        strokeWidth="2px"
                        size="15px"
                      />
                      <span
                        className="custom-provider-type-color"
                        style={labelIcon?.color ? { color: labelIcon.color } : {}}
                      >
                        {labelIcon?.name}
                      </span>
                    </span>
                  )
                }
              >
                <Dropdown.Menu>
                  {companyLabels?.map((companyLabel) => (
                    <Dropdown.Item
                      key={companyLabel.key}
                      value={companyLabel.key}
                      onClick={(_, val) => onChange("nominasLabel", val.value)}
                      style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                    >
                      <FeatherIcon
                        icon={companyLabel.icon}
                        color={companyLabel.color}
                        strokeWidth="2px"
                        size="15px"
                        style={{ marginRight: "8px" }}
                      />
                      <span>{companyLabel.name}</span>
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      )}

      <div className="parametrization-buttons">
        <button
          type="button"
          className="parametrization-btn parametrization-btn--primary"
          disabled={loading}
          onClick={(e) => {
            e.preventDefault();
            onSubmit();
          }}
        >
          {loading ? t("parametrization.saving") : t("parametrization.saveChanges")}
        </button>
        <button
          type="button"
          className="parametrization-btn parametrization-btn--secondary"
        >
          {t("parametrization.cancelChanges")}
        </button>
      </div>
    </div>
  );
};
